export const defaultPostChatSurveyPaneGeneralStyles = {
  borderStyle: "solid",
  borderRadius: 0,
  borderWidth: "3px",
  backgroundColor: "#FFFFFF",
  borderColor: "#F1F1F1"
};